import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=53d2e9a0&"
import script from "./Billing.vue?vue&type=script&lang=js&"
export * from "./Billing.vue?vue&type=script&lang=js&"
import style0 from "./Billing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BToast, BInputGroupPrepend, BInputGroup, BModal, BIconCreditCard, BTh, BTr, BThead, BTd, BImg, BBadge, BTbody, BTableSimple, BCard, BCol, BRow, BIconCardHeading, BFormInput, BFormInvalidFeedback, BFormGroup, BFormSelect, BIconCheck2All, BForm, BContainer} from 'bootstrap-vue'
    installComponents(component, {BButton, BToast, BInputGroupPrepend, BInputGroup, BModal, BIconCreditCard, BTh, BTr, BThead, BTd, BImg, BBadge, BTbody, BTableSimple, BCard, BCol, BRow, BIconCardHeading, BFormInput, BFormInvalidFeedback, BFormGroup, BFormSelect, BIconCheck2All, BForm, BContainer})
    

export default component.exports